import { INewbuildingBuilder } from '../../types/newbuilding/builder';

export function getPageData(builder: INewbuildingBuilder | null) {
  if (!builder || !builder.phoneAnalyticsData) {
    return {};
  }

  const { phoneAnalyticsData, phone } = builder;

  return {
    dealType: phoneAnalyticsData && phoneAnalyticsData.dealType,
    objectType: phoneAnalyticsData && phoneAnalyticsData.objectType,
    offerID: builder.id,
    offerPhone: phone ? `${phone.countryCode}${phone.code}${phone.number}` : '',
  };
}
